import { useTranslation } from 'react-i18next';
import { useAppStateStorage } from './use-local-storage.hook';
import { useEffect } from 'react';

export const useTranslate = () => {
  const { t, i18n } = useTranslation();

  // Initialize language from local storage on mount
  useEffect(() => {
    const savedState = useAppStateStorage.get();
    if (savedState.language && savedState.language !== i18n.language) {
      i18n.changeLanguage(savedState.language);
    }
  }, [i18n]);

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    useAppStateStorage.setLanguage(lang);
  };

  return {
    t,
    i18n,
    currentLanguage: i18n.language,
    changeLanguage,
    languages: ['en', 'fr', 'ar'], // Add more languages as needed
  };
};
